import React from 'react';

function DashboardIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g id="bar-chart">
        <path
          id="Vector"
          d="M9.33333 13.3334V2.66669H6.66667V13.3334M9.33333 13.3334H6.66667M9.33333 13.3334H12V6.00002H9.33333V13.3334ZM6.66667 13.3334V8.66669H4V13.3334H6.66667ZM2 13.3334H14"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default DashboardIcon;
